const state = {
  isLoading: false,
  selectedGroupName: localStorage.getItem('selectedGroupName') || null,
  selectedPropertyId: localStorage.getItem('selectedPropertyId') || null,
  isEditing: false
}

const getters = {
  currentLoading: (state) => state.isLoading,
  selectedGroupName: (state) => state.selectedGroupName,
  selectedPropertyId: (state) => state.selectedPropertyId,
  isEditing: (state) => state.isEditing
}

const actions = {
  changeLoading({ commit }, newLoading) {
    commit('setLoading', newLoading)
  },
  changeSelectedGroupName({ commit }, groupName) {
    commit('setSelectedGroupName', groupName)
  },
  changeSelectedPropertyId({ commit }, propertyId) {
    commit('setSelectedPropertyId', propertyId)
  },
  changeIsEditing({ commit }, isEditing) {
    commit('setIsEditing', isEditing);
  }
}

const mutations = {
  setLoading: (state, newLoading) => (state.isLoading = newLoading),
  setSelectedGroupName: (state, groupName) => {state.selectedGroupName = groupName; localStorage.setItem('selectedGroupName', groupName)},
  setSelectedPropertyId: (state, propertyId) => { state.selectedPropertyId = propertyId; localStorage.setItem('selectedPropertyId', propertyId) },
  setIsEditing: (state, isEditing) => { state.isEditing = isEditing; }
}

export default {
  state,
  getters,
  actions,
  mutations
}

